<template>
  <!-- 261026 오전 대표 회의 ⑦ "옛날 커피 이벤트처럼 앱 열면 주차 QR 할인 판매 창을 올려라" · "받아도 파는 물건인 걸 알게".
       문구 A(정가 취소선 → 할인가 — 261027 유저 확정, 홈 주차 QR 칸과 같은 값). 홈(ServiceLanding)이 앱을 켤 때 한 번 띄운다. 틀 = QrPreOrderSheet. -->
  <div class="modal-dim on ps-dim">
    <div class="ps-sheet-wrap" @click.self="emits('close')">
      <div class="ps-sheet modal" role="dialog" aria-labelledby="ps-sheet-title">
        <button type="button" class="ps-sheet__x" aria-label="닫기" @click="emits('close')">×</button>
        <p class="ps-sheet__eyebrow">간판ON 주차 QR</p>
        <p id="ps-sheet-title" class="ps-sheet__title">주차 QR<br>지금 할인 판매 중</p>
        <img class="ps-sheet__photo" :src="imgParkingCard" width="950" height="565" alt="차 앞 유리 안쪽에 둔 투명 아크릴 주차 QR">
        <p class="ps-sheet__lead">차 앞 유리 전화번호 대신 QR을 두세요. 찍으면 차주에게 바로 연락이 갑니다.</p>
        <p class="ps-sheet__price"><s class="ps-sheet__price-list">정가 {{ PARKING_PRICE.list }}</s><strong class="ps-sheet__price-now">{{ PARKING_PRICE.now }}</strong></p>
        <p class="ps-sheet__gift">사은품으로 받으셨나요? 간판ON이 판매하는 상품입니다.</p>
        <!-- .stop — 클릭이 창 뿌리의 '바깥 누르면 닫기'(views/index.vue modalOutSideEvent)까지 가면 방금 연 신청 창을 닫는다(261027 테섭 E2E) -->
        <button type="button" class="ps-sheet__cta" @click.stop="fnAsk">{{ STORE_CTA_LABEL }}</button>
        <div class="ps-sheet__foot">
          <button type="button" class="ps-sheet__hide" @click="fnHideToday">오늘 하루 보지 않기</button>
          <button type="button" class="ps-sheet__close" @click="emits('close')">닫기</button>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup>
import { openSmartStore, STORE_CTA_LABEL } from '@/common/utils/smartStore';
import { PARKING_PRICE, PARKING_SALE_HIDE_KEY, localDay } from '@/common/utils/parkingSale.mjs';
import imgParkingCard from '@/assets/static/images/qr/parking/parking-card-photo.jpg';

const emits = defineEmits(['close']);

// 홈 주차 QR 칸 버튼과 같은 신청 창(스토어 열기 전엔 사전 신청) — entry 로 이 창에서 온 걸 남긴다
const fnAsk = () => {
  emits('close');
  openSmartStore({ entry: 'popup-parking', product: '주차 QR' });
};

const fnHideToday = () => {
  try { localStorage.setItem(PARKING_SALE_HIDE_KEY, localDay()); } catch { /* noop */ }
  emits('close');
};
</script>

<style scoped>
/* 홈 머리띠(.gp-site-header z 40) 위 — 전역 .modal-dim(20)만으론 머리띠가 어두운 막 위에 남아 눌린다. 홈 안 창(공유·영상 60↑)보단 아래 */
.ps-dim { z-index: 50; }
.ps-sheet-wrap { position: absolute; inset: 0; z-index: 1; display: flex; align-items: flex-end; justify-content: center; }
.ps-sheet.modal {
  position: relative;
  box-sizing: border-box;
  width: 100%; min-width: 0; max-width: 600px; max-height: 90%;
  overflow-y: auto; overscroll-behavior-y: contain;
  padding: 22px 20px calc(8px + env(safe-area-inset-bottom));
  border-radius: 20px 20px 0 0; background: #fff;
  box-shadow: 0 -8px 32px rgba(15, 31, 61, .12);
  color: #0F1F3D; font-family: 'Pretendard', system-ui, -apple-system, sans-serif;
  font-size: 16px; line-height: 1.5; letter-spacing: -0.02em; text-align: left;
  word-break: keep-all; overflow-wrap: break-word;
  animation: psSheetUp .3s ease;
}
@keyframes psSheetUp { from { transform: translateY(100%); } to { transform: translateY(0); } }
.ps-sheet__x { position: absolute; top: 10px; right: 12px; width: 44px; height: 44px; padding: 0; border: 0; background: none; color: #90A4AE; font-size: 28px; line-height: 1; cursor: pointer; }
.ps-sheet__eyebrow { margin: 0 0 6px; color: #2F6DF6; font-size: 15px; font-weight: 700; }
.ps-sheet__title { margin: 0 0 12px; font-size: 24px; font-weight: 800; line-height: 1.35; letter-spacing: -0.03em; }
/* 짧은 폰(SE 앱 본문 약 650px)에서 창이 넘치지 않게 사진 높이를 화면 높이에 맞춘다 */
.ps-sheet__photo { display: block; width: 100%; height: auto; max-height: min(180px, 22vh); object-fit: cover; margin: 0 0 12px; border-radius: 14px; }
.ps-sheet__lead { margin: 0 0 12px; color: #4C5A70; font-size: 16px; line-height: 1.55; }
.ps-sheet__price { display: flex; flex-wrap: wrap; align-items: baseline; gap: 4px 10px; margin: 0 0 6px; }
.ps-sheet__price-list { color: #90A4AE; font-size: 17px; }
.ps-sheet__price-now { color: #2F6DF6; font-size: 30px; font-weight: 800; line-height: 1.2; }
.ps-sheet__gift { margin: 0 0 14px; color: #546E7A; font-size: 16px; line-height: 1.5; }
.ps-sheet__cta { width: 100%; min-height: 56px; padding: 12px 16px; border: 0; border-radius: 14px; background: #2F6DF6; color: #fff; font-family: inherit; font-size: 18px; font-weight: 800; line-height: 1.4; cursor: pointer; }
/* jump-user 전역 button{width:100%} — 한 줄에 두 버튼이라 width:auto 로 되돌린다 */
.ps-sheet__foot { display: flex; justify-content: space-between; align-items: center; margin-top: 4px; }
.ps-sheet__hide, .ps-sheet__close { width: auto; min-height: 48px; padding: 8px 4px; border: 0; background: none; font-family: inherit; font-size: 16px; line-height: 1.4; cursor: pointer; }
.ps-sheet__hide { color: #8A94A6; }
.ps-sheet__close { color: #1D2939; font-weight: 700; }
.ps-sheet__cta:focus-visible, .ps-sheet__hide:focus-visible, .ps-sheet__close:focus-visible, .ps-sheet__x:focus-visible { outline: 3px solid #0F1F3D; outline-offset: 2px; }
.ps-sheet__cta:active { filter: brightness(.95); }
@media (max-width: 374px) { .ps-sheet.modal { padding-right: 16px; padding-left: 16px; } }
@media (prefers-reduced-motion: reduce) { .ps-sheet.modal { animation: none; } }
</style>
